module.exports = __webpack_public_path__ + "static/media/img_bt.2e726612.svg";